<template>
  <v-navigation-drawer
    app
    width="280"
    id="app-drawer"
    v-model="drawer"
    enable-resize-watcher
    floating
    mini-variant-width="70"
    class="vuse-sidebar"
    :mini-variant="isMinSideNav"
    :expand-on-hover="isMinSideNav"
    :left="!isSidenavPostionRight"
    :right="isSidenavPostionRight"
    :clipped="isClippedOver"
    :dark="semidark"
    :class="!semidark ? 'neu-glow' : ''"
    v-if="!isRolDisplayUser()"
  >
    <!-- App Logo -->
    <v-list-item
      v-if="!isClippedOver"
      :class="{ 'logo-section': true, 'semi-dark': semidark }"
      class="ml-1"
    >
      <v-list-item-avatar tile height="50" width="40">
        <v-img
          src="/static/fs/symbol-logo_fs_sinfondo.png"
          lazy-src="/static/fs/symbol-logo_fs_sinfondo.png"
          alt="Logo Futurespace"
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title primary--text">
          <h2>{{ $t('Global.Main.appName') }}</h2>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-sheet color="transparent" :height="!isClippedOver ? 80 : 15" />
    <v-list
      dense
      v-bind="{ ...activeItemStyle }"
      expand="expand"
      class="nav-drawer transparent"
      id="app-sidebar"
    >
      <template v-for="(item, i) in itm">
        <ListGroup v-bind="item" :key="i" v-if="item.items && isVisible(item.roles)" class="pr-0 pl-6"/>
        <v-subheader
          v-else-if="item.header && isVisible(item.roles)"
          class="heading-text ml-2 nav-subheader"
          :key="`${i}-item`"
          :class="{ 'mt-3': i !== 0 }"
        >
          <v-icon class="ml-n1">more_horiz</v-icon>
          <span>
            <h3>{{ item.header }}</h3>
          </span>
        </v-subheader>
        <v-subheader
          v-else-if="item.subHeader && isVisible(item.roles)"
          class="text-capitalize text-center ml-2 "
          :key="`${i}-item`"
          :class="{ 'mt-3': i !== 0 }"

        >
          <v-icon class="ml-3" x-small>{{ item.icon }}</v-icon>
          <span class="ml-1" >
            <h4>{{ item.subHeader.toUpperCase() }}</h4>
          </span>
        </v-subheader>
        <NavigationItem v-else :key="`si-${i}`" v-bind="item" :show="isVisible(item.roles)" class="pr-0 pl-6"/>
      </template>
      <v-spacer class="mb-5"></v-spacer>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters} from "vuex";
import appDrawerItems from "@/config/navigation-items";
import ListGroup from "@/components/UI/NavigationItems/ListGroup";
import NavigationItem from "@/components/UI/NavigationItems/NavigationItem";
import has from "lodash/has";
import ROL from "@/config/rol-values";

export default {
  components: {
    ListGroup,
    NavigationItem,
  },
  data() {
    return {
      items: appDrawerItems,
      rol: ROL
    };
  },
  computed: {
    activeItemStyle: (state) => state.activeMenuStyle,
    ...mapGetters("navigations", [
      "isVisibleSideNav",
      "isMinSideNav",
      "activeItemStyle",
      "isSidenavPostionRight",
      "isClippedOver",
    ]),
    ...mapGetters("scheme", ["semidark"]),
    ...mapGetters(["getRoleId"]),
    activemenu() {
      return this.$vuetify.theme.activemenu;
    },
    drawer: {
      get() {
        return this.isVisibleSideNav;
      },
      set(value) {
        this.$store.dispatch("navigations/setSidenavVisibility", value);
      },
    },
    itm() {
      return this.items.map(this.addLanguagePrefix);
    },
  },
  methods: {
    isVisible(roles) {
      return !!(roles.includes(this.getRoleId))
    },
    addLanguagePrefix(item) {
      const { items, ...props } = item;

      let newVal = { title: this.$t(`Global.Main.${item.i18n}`) }
      if (has(props, "subHeader")) {
        console.log('subHeader', item)
        newVal = { subHeader: this.$t(`Global.Main.${item.i18n}`) }
      }
      if (has(props, "header") ) {
        newVal = { header: this.$t(`Global.Main.${item.i18n}`) }
      }

      const newItem = {
        ...props,
        ...newVal,
      };

      if (items) {
        newItem.items = items.map(this.addLanguagePrefix);
      }

      return newItem;
    },
    isRolDisplayUser(){
      return [this.rol.DISPLAY_USER].includes(this.getRoleId)
    }
  }
};
</script>
